<template>
  <div class="statistics">
    <div class="stat">
      <span class="stat-label">Pain with full bladder today: </span>

      <span class="stat-stat">
        {{ existingEntry.data.fullBladderPain / 10 }}
      </span>
    </div>

    <div class="stat">
      <span class="stat-label">
        Pain with emptying bladder today:
      </span>

      <span class="stat-stat">
        {{ existingEntry.data.emptyBladderPain / 10 }}
      </span>
    </div>

    <div class="stat">
      <span class="stat-label">
        Has frequent urination been a problem today?
      </span>

      <span class="stat-stat">
        {{ existingEntry.data.frequentUrination }}
      </span>
    </div>

    <div class="stat">
      <span class="stat-label">
        Has getting up at night to urinate been a problem last night?
      </span>

      <span class="stat-stat">
        {{ existingEntry.data.nightUrination }}
      </span>
    </div>

    <div class="stat">
      <span class="stat-label">
        Has needing to urinate with little warning been a problem today?
      </span>

      <span class="stat-stat">
        {{ existingEntry.data.warningUrination }}
      </span>
    </div>

    <div class="stat">
      <span class="stat-label">
        Has burning, pain, discomfort, or pressure in bladder been a problem
        today?
      </span>

      <span class="stat-stat">
        {{ existingEntry.data.painUrination }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Stats",
  props: ["existingEntry"],
};
</script>

<style></style>
